export default {
    showMessage: function (messageValue) {
        alert(messageValue);
    },
    reloadPage: function () {
        window.location.reload();
    },
    goToUrl: function (url) {
        window.location = url;
    },
    goToUrlBlank: function (url) {
        window.open(url, '_blank');
    }
};


// WEBPACK FOOTER //
// ./src/common.js